<template>
  <div id="app">
    <IndexHead :indexhead="indexhead"></IndexHead> 
    <div class="indexMain">
      <router-view v-if="token" @changeIndexHeadFunc="changeIndexHeadFunc" @changeindexhead="changeindexhead" :token="token"/>
      <div class="nonetoken" v-else>
        <img src="./assets/ywLogo.png" alt="">
        <div>微信扫码关注“远微商城”，不迷路~</div>
      </div>
    </div> 
    <div class="footer">Copyright © 2019 远特（北京）通信技术有限公司</div>
  </div>
</template>

<script>
import IndexHead from "@/components/index/indexHead.vue";
export default {
  name: "index",
  components: {
    IndexHead
  },
  data(){
    return {
      token : null,
      indexhead : '1',
    }
  },
  methods: {
    getUrlParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
      var r = window.location.search.substr(1).match(reg);  //匹配目标参数
      if (r != null) return unescape(r[2]); //返回参数值
    },
    changeIndexHeadFunc : function(indexhead){
      this.indexhead = indexhead;
    },
    changeindexhead : function(indexhead){
      this.indexhead = indexhead;
    }
  },
  created:function(){
  },
  mounted () {
    this.token = this.getUrlParam('token');
    if(this.token == undefined){
      console.log("undefined")
    }
    this.$store.commit('tokenFunc',this.token);
  }
};
</script>

<style lang="less">
* {
  margin: 0;
  padding: 0;
}
html,body {
  width: 100%;
  height: 100%;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background: #F0F2F5;
  text-align: center;
  width: 100%;
  height: 100%;
  overflow: auto;
  position: absolute;
  .indexMain{
    min-width: 1280px;
    padding: 20px 0;
    width: 80%;
    margin: 0 auto;
    .nonetoken{
      padding-top: 200px;
      font-size: 26px;
      line-height: 50px;
      img{
        width: 290px;
        height: 290px;
      }
    }
  }
  .footer {
    width: 100%;
    color: #959698;
    font-size: 12px;
    padding: 20px 0;
    position: relative;
    bottom: 0;
    text-align: center;
    
  }
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
